/* @flow */

import React from 'react'

// draws a path that represents the upper half of a circle
export default function SVGUpperHalfCircle({
  cx,
  cy,
  r,
  stroke,
  strokeWidth,
  ...otherProps
}: {
  cx: number,
  cy: number,
  r: number,
  stroke: string,
  strokeWidth: string,
}) {
  // move at positive angles along the circle
  // this draws the upper half rather than the lower half
  const sweepFlag = 1

  // https://developer.mozilla.org/en/docs/Web/SVG/Tutorial/Paths
  // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/d

  const pathCommands = [
    // move to first point
    `M ${cx - r},${cy}`,
    // arc to end point (arcs are sections of circles)
    `A ${r},${r} ${0} ${0} ${sweepFlag} ${cx + r},${cy}`,
  ]

  return (
    <path
      d={pathCommands.join(' ')}
      {...otherProps}
      stroke={stroke}
      strokeWidth={strokeWidth}
      fill="none"
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/SVGUpperHalfCircle.js